<script>
import eventHelper from "@/mixins/eventHelper.js";
import apiHelper from "@/mixins/apiHelper.js";

export default {
  emits: ['eventDateChanged','eventChangeCanceled'],
  mixins: [
    eventHelper,
    apiHelper
  ],
  data() {
    return {
      dialog: false,
      eventDropInfo: null,
    }
  },
  methods: {
    // /**
    //  * Change all events on recurring event is not working very well.
    //  * For example: On a recurring event that is repeating every month on the first monday, the delta change won't do much.
    //  */
    // changeAllEvents() {
    //   // Change event date by sending a PATCH request to the API
    //   this.changeEventDate(this.eventDropInfo);
    //   // Close dialog
    //   this.closeDialog();
    //   // Emit event
    //   this.$emit('eventDateChanged');
    //   // Show message
    //   this.$toast.add({ severity: 'success', summary: 'Activiteiten verplaatst', detail: 'Alle activiteiten zijn verplaatst.', group: 'global', life: 4000 });
    // },
    /**
     * Create a new event by sending a PATCH request to the API.
     */
    async changeEventDate(eventDropInfo) {
      // Post new event to the API
      let payload = {};

      // Save the event drop info
      this.eventDropInfo = eventDropInfo;
      // Get event
      let event = eventDropInfo.event;
      // Get the allDay status of the new event
      payload.allDay = event.allDay;
      // Get the delta change in time
      payload.delta = eventDropInfo.delta;

      // Send request to API
      const response = await fetch('/api/event/'+event.id+'/change-date', {
        method: 'PATCH',
        credentials: "include", // Set to make sure the cookies are send with the request.
        headers: this.requestHeaders,
        body: JSON.stringify(payload)
      });

      const status_code = response.status;

      if (status_code === 200) {
        // Emit event
        this.$emit('eventDateChanged');
        return true;
      }

      let response_data = await response.json();
      // Show error message
      this.$toast.add({ severity: 'error', summary: 'Fout', detail: 'De activiteit kon niet verplaatst worden.', group: 'errors' });
      // Revert event
      eventDropInfo.revert();
      return false;

    },
  }
}
</script>

<template>

  <Toast position="top-center" group="global" />

</template>

<style>
 /* See agenda.scss for styling. Styling is here because we want the Gin/Bootstrap variables. */
</style>
